import { jsx as i } from "react/jsx-runtime";
import { an as f, aP as _, aQ as m, d as l } from "../../vendor-EQDp64ng.js";
import { useRef as p } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as x } from "../../utils/omitStyleRenderProps/index.js";
import { useAutoResize as b, supportsFieldSizing as d } from "./useAutoResize.js";
import '../../assets/index57.css';const u = "_textArea_1wr9r_1", $ = "_autoResize_1wr9r_44", A = "_both_1wr9r_48", R = "_vertical_1wr9r_52", w = "_none_1wr9r_56", t = {
  textArea: u,
  autoResize: $,
  both: A,
  vertical: R,
  none: w
};
function g({
  className: a,
  resize: s = "both",
  autoResize: o = !1,
  maxRows: c,
  ...r
}) {
  const e = p(null), [{ value: n }] = f(r, e, _);
  return b(e, { isEnabled: o, value: n, maxRows: c }), /* @__PURE__ */ i(
    m,
    {
      ...x(r),
      ref: e,
      className: l(t.textArea, t[s], a, {
        [t.autoResize]: o && d
      }),
      "data-component": "TextArea"
    }
  );
}
export {
  g as TextArea
};
